

























































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class RecordFooter extends Vue {
  private visible: boolean = false;

  get hasBuffer() { return !this.records.scanning && this.records.scanRowCount > 0; }

  get bufferTotalPages() {
    return Math.ceil(this.records.scanRowCount / (this.records.limit || 500)) || 1;
  }

  @Prop(Function) private generateMeta: any;
  @Prop(Function) private refreshTable: any;
  @Prop(Function) private getNextRecords: any;
  @Prop(Object) private records!: any;
  @Prop(Function) private getPreviousRecords: any;
  @Prop(Function) private getLimitedRows: any;
  @Prop(Function) private cancelScan: any;
  @Prop(Function) private bufferPageNext: any;
  @Prop(Function) private bufferPagePrev: any;
  @Prop(Function) private setPaginationMode: any;
  @Prop(String) private currentTable!: string;
  @Prop(Number) private itemCount!: number;
  @Prop(Array) private list!: any[];

  private onPaginationModeChange(mode: string) {
    this.setPaginationMode(mode);
    this.getLimitedRows(this.records.limit || 100);
  }

  private onRowsPerPageChange(val: any) {
    this.getLimitedRows(val);
  }
}
